// ============================================================
// DESTINO: frontend/src/components/pinwin/JoinPage.jsx
// ============================================================
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function JoinPage() {
  const { code } = useParams();
  const [tried, setTried] = useState(false);

  const deepLink = `pinwin://join/${code}`;

  // Detecta plataforma
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /android/i.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;

  const storeUrl = isIOS
    ? "https://apps.apple.com/app/pinwin/id0000000000"
    : "https://play.google.com/store/apps/details?id=social.pinwin.app";

  const storeLabel = isIOS ? "Download on App Store" : "Download on Play Store";

  const openApp = () => {
    window.location.href = deepLink;
    // Se depois de 2.5s o usuario ainda ta aqui, o app nao abriu
    setTimeout(() => setTried(true), 2500);
  };

  // No mobile, tenta abrir o app automaticamente
  useEffect(() => {
    if (isMobile && code) {
      openApp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fade = (d = 0) => ({
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, delay: d },
  });

  if (!code) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
        <div className="text-center max-w-sm">
          <p className="text-5xl mb-4">❌</p>
          <h1 className="font-anton text-2xl text-white uppercase mb-2">
            Invalid link
          </h1>
          <p className="font-body text-sm text-white/50 mb-8">
            This invite link is missing the squad code.
          </p>
          <Link
            to="/"
            className="inline-block font-mono-pw text-sm tracking-widest text-black bg-[#E6FF00] px-8 py-3 uppercase"
          >
            Go to PINWIN
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center px-6 py-16">
      <motion.div {...fade(0)} className="text-center max-w-md w-full">

        <motion.p {...fade(0.1)} className="text-6xl mb-6">🏆</motion.p>

        <motion.h1
          {...fade(0.2)}
          className="font-anton text-3xl md:text-4xl text-white uppercase leading-tight mb-3"
        >
          You got a <span className="text-[#E6FF00]">Squad</span> invite!
        </motion.h1>

        <motion.p {...fade(0.3)} className="font-body text-sm text-white/60 mb-4">
          Someone added you to their Squad on PINWIN.
          <br />Open the app to join and start pinning wins.
        </motion.p>

        <motion.div {...fade(0.35)} className="mb-8">
          <div className="inline-block border border-white/10 px-6 py-3">
            <p className="font-mono-pw text-[11px] text-white/40 tracking-widest uppercase mb-1">
              Invite code
            </p>
            <p className="font-anton text-2xl text-[#E6FF00] tracking-wider">
              {code}
            </p>
          </div>
        </motion.div>

        <motion.div {...fade(0.5)} className="space-y-3">
          <button
            onClick={openApp}
            className="block w-full font-mono-pw text-sm tracking-widest text-black bg-[#E6FF00] px-8 py-4 uppercase text-center hover:brightness-110 transition-all cursor-pointer"
          >
            Open in PINWIN
          </button>

          {tried && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="space-y-3"
            >
              <p className="font-body text-xs text-white/40">
                App not installed?
              </p>
              <a
                href={storeUrl}
                className="block font-mono-pw text-xs tracking-widest text-[#E6FF00] underline underline-offset-4 hover:brightness-110 transition-all"
              >
                {storeLabel}
              </a>
            </motion.div>
          )}
        </motion.div>

        <motion.p
          {...fade(0.6)}
          className="font-mono-pw text-[10px] text-white/20 tracking-[4px] uppercase mt-12"
        >
          PINWIN.SOCIAL
        </motion.p>
      </motion.div>
    </div>
  );
}
